import { useTheme } from "next-themes";
import { Moon, Sun } from "lucide-react";

/**
 * Light / dark switch for the sidebar footer.
 *
 * next-themes stores the choice in localStorage ("vacars-theme") and puts
 * .light or .dark on <html> before first paint, so there is no dark flash on
 * a light reload. Dark is the default: index.css's :root values ARE the dark
 * theme, and only :root.light overrides them.
 */
export default function ThemeToggle() {
  const { resolvedTheme, setTheme } = useTheme();
  const isLight = resolvedTheme === "light";
  const next = isLight ? "dark" : "light";

  return (
    <button
      type="button"
      onClick={() => setTheme(next)}
      data-testid="btn-theme-toggle"
      aria-label={`Switch to ${next} theme`}
      title={`Switch to ${next} theme`}
      className="w-full flex items-center gap-3 px-3 py-2 rounded-md text-sm text-muted-foreground hover:text-foreground hover:bg-secondary transition-colors"
    >
      {isLight ? <Moon className="w-4 h-4" /> : <Sun className="w-4 h-4" />}
      <span className="flex-1 text-left">{isLight ? "Dark theme" : "Light theme"}</span>
    </button>
  );
}
